import { Tour } from "nextstepjs";
import { getDeviceType } from "@/helpers/storeLocatorHelper";
const deviceType = getDeviceType();

const manageListFilterGuide: any[] = [
  {
    tour: "manageListFilter",
    steps: [
      {
        icon: "",
        title: "",
        content: "Add custom ingredients directly to your shopping list.",
        selector: "#add_new_list",
        side: deviceType === "mobile" ? "top-right" : "bottom",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: "",
        title: "",
        content: "Add custom ingredients directly to your shopping list.",
        selector: "#add_new_Cutom_list_item",
        side: deviceType === "mobile" ? "top-left" : "bottom-left",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: "",
        title: "",
        content:
          "Sort your shopping list based on your preferences for a more organized shopping experience.",
        selector: "#manageList_filters_deskTop",
        side: "bottom-left",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
        hideOnMobile: true,
      },
      {
        icon: "",
        title: "",
        content:
          "Sort your shopping list based on your preferences for a more organized shopping experience.",
        selector: "#manageList_filters_mobile",
        side: deviceType === "mobile" ? "top-right" : "bottom-right",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
        hideOnMobile: false,
      },
      {
        icon: "",
        title: "",
        content:
          "These offers are automatically added to your shopping list to ensure you don’t miss on rewards and savings tied to your overall shopping list.",
        selector: "#auto_added_offers",
        side: "top",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
    ],
  },
];

export default manageListFilterGuide;
